import React, { useEffect, useRef } from 'react';
import { MarketplaceBuyerProfile } from '../../../slices/marketplace/buyer/models/buyer-profile';
import * as yup from 'yup';
import ButtonLoader from '../../Layout/Buttons/ButtonLoader';
import { Form, Input, Label } from '@availity/form';
import { Col, Row } from 'reactstrap';
import { PrefilledTags } from '../../../models/PrefilledTags/PrefilledTags';
import { DocumentTagEnum } from '../../../models/PrefilledTags/DocumentTagEnum';

interface IdNdaLegalDocumentInfo {
    fullCorporateLegalName: string;
    contactName: string;
    contactTitle: string;
}

interface IdNdaLegalInformationFormProps {
    onClose(): void;
    onSubmit(prefilledTags: PrefilledTags[]): void;
    isLoading?: boolean;
    buyerProfile: MarketplaceBuyerProfile;
    opportunityId: number;
}
export const IdNdaLegalInformationForm = (
    props: IdNdaLegalInformationFormProps
) => {
    let formRef = useRef(null);

    useEffect(() => {
        if (formRef) {
            initializeForm();
        }
    }, [formRef]);

    const initializeForm = () => {
        const legalDocumentInfo: IdNdaLegalDocumentInfo = {
            fullCorporateLegalName:
                props.buyerProfile?.legalDocumentInputs
                    ?.fullCorporateLegalName ?? '',
            contactName:
                props.buyerProfile?.legalDocumentInputs?.contactName ?? '',
            contactTitle:
                props.buyerProfile?.legalDocumentInputs?.contactTitle ?? '',
        };

        formRef?.current?.setFieldValue(
            'fullCorporateLegalName',
            legalDocumentInfo.fullCorporateLegalName,
            false
        );
        formRef?.current?.setFieldValue(
            'contactName',
            legalDocumentInfo.contactName,
            false
        );
        formRef?.current?.setFieldValue(
            'contactTitle',
            legalDocumentInfo.contactTitle,
            false
        );
    };

    const mapToPrefilledTags = (documentInfo: IdNdaLegalDocumentInfo) => {
        return [
            {
                tagEnum: DocumentTagEnum.BuyerLegalName,
                value: documentInfo.fullCorporateLegalName,
            },
            {
                tagEnum: DocumentTagEnum.BuyerLegalContactName,
                value: documentInfo.contactName,
            },
            {
                tagEnum: DocumentTagEnum.BuyerLegalContactTitle,
                value: documentInfo.contactTitle,
            },
            {
                tagEnum: DocumentTagEnum.OppId,
                value: props.opportunityId.toString(),
            },
        ];
    };

    return (
        <Form
            innerRef={formRef}
            initialValues={{
                fullCorporateLegalName: '',
                contactName: '',
                contactTitle: '',
            }}
            validationSchema={yup.object().shape({
                fullCorporateLegalName: yup.string().trim().required(),
                contactName: yup.string().trim().required(),
                contactTitle: yup.string().trim().required(),
            })}
            onSubmit={(values) => {
                const trimmedValues = {
                    fullCorporateLegalName:
                        values.fullCorporateLegalName.trim(),
                    contactName: values.contactName.trim(),
                    contactTitle: values.contactTitle.trim(),
                };
                props.onSubmit(mapToPrefilledTags(trimmedValues));
            }}>
            <div className="rows-container">
                <Row>
                    <Col md={6}>
                        <Label>{'Buyer Legal Name'}</Label>
                        <Input name="fullCorporateLegalName"></Input>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Label>{'Buyer Signatory'}</Label>
                        <Input name="contactName"></Input>
                    </Col>
                    <Col md={6}>
                        <Label>{'Buyer Signatory Title'}</Label>
                        <Input name="contactTitle"></Input>
                    </Col>
                </Row>
                <div className="buttons-wrapper">
                    <button
                        className="btn btn-cancel"
                        onClick={() => {
                            props.onClose();
                        }}
                        disabled={props.isLoading}>
                        {'Cancel'}
                    </button>
                    <ButtonLoader
                        disabled={props.isLoading}
                        isLoading={props.isLoading}
                        className="btn btn-primary"
                        buttonText={'Confirm'}
                        loaderButtonText={''}
                        onClick={() => {}}></ButtonLoader>
                </div>
            </div>
        </Form>
    );
};
